import { useQuery } from '@apollo/client';
import { useWarehouseContext } from '../../../../contexts/WarehouseContext';
import {
  GET_WMS_PROGRESS, 
  GetWmsProgressResponse, 
  WmsProgressFilterInput,
  WmsProgressType 
} from '../graphql/queries/getWmsProgress';
import {
  GET_WMS_PROGRESS_BY_PREVIOUS_STATION,
  GetWmsProgressByPreviousStationResponse,
  WmsProgressByPreviousStationType
} from '../graphql/queries/getWmsProgressByPreviousStation';

export interface WmsProgressQueryResult {
  progressData: WmsProgressType[];
  loading: boolean;
  refetch: (variables?: any) => Promise<any>;
  buildQueryVariables: () => WmsProgressFilterInput;
}

export interface WmsProgressByPreviousStationQueryResult {
  progressData: WmsProgressByPreviousStationType[];
  loading: boolean;
  refetch: (variables?: any) => Promise<any>;
  buildQueryVariables: () => WmsProgressFilterInput;
}

export const useWmsProgressQuery = (appliedFilters?: WmsProgressFilterInput): WmsProgressQueryResult => {
  const { currentWarehouse } = useWarehouseContext();
  
  const buildQueryVariables = (): WmsProgressFilterInput => {
    // 合并传入的filter条件和默认的warehouse条件
    return {
      currentWarehouseId: currentWarehouse?.id ? Number(currentWarehouse.id) : 0,
      channelId: appliedFilters?.channelId,
      arrivedCurrentWarehouseDateRange: appliedFilters?.arrivedCurrentWarehouseDateRange,
      carrierCode: appliedFilters?.carrierCode
    };
  };

  const { data, loading, refetch } = useQuery<GetWmsProgressResponse>(
    GET_WMS_PROGRESS,
    {
      variables: { filter: buildQueryVariables() },
      skip: !currentWarehouse?.id
    }
  );

  return {
    progressData: data?.getWmsProgress || [],
    loading,
    refetch,
    buildQueryVariables
  };
};

// 导出别名以保持一致性
export const useWmsProgressByDestinationQuery = useWmsProgressQuery;

export const useWmsProgressByPreviousStationQuery = (appliedFilters?: WmsProgressFilterInput): WmsProgressByPreviousStationQueryResult => {
  const { currentWarehouse } = useWarehouseContext();
  
  const buildQueryVariables = (): WmsProgressFilterInput => {
    // 合并传入的filter条件和默认的warehouse条件
    return {
      currentWarehouseId: currentWarehouse?.id ? Number(currentWarehouse.id) : 0,
      channelId: appliedFilters?.channelId,
      arrivedCurrentWarehouseDateRange: appliedFilters?.arrivedCurrentWarehouseDateRange,
      carrierCode: appliedFilters?.carrierCode
    };
  };

  const { data, loading, refetch } = useQuery<GetWmsProgressByPreviousStationResponse>(
    GET_WMS_PROGRESS_BY_PREVIOUS_STATION,
    {
      variables: { filter: buildQueryVariables() },
      skip: !currentWarehouse?.id
    }
  );

  return {
    progressData: data?.getWmsProgressByPreviousStation || [],
    loading,
    refetch,
    buildQueryVariables
  };
}; 